const WarningTypesEnum=
{
    WithComment:'WithComment',
    WithTwoButtons:'WithTwoButtons',
    WithOneButton:'WithOneButton',
};
export default WarningTypesEnum;